import React, { useContext } from 'react'

export const GeneralContext = React.createContext()
GeneralContext.displayName = 'GeneralContext'

export const useGeneralContext = () => useContext(GeneralContext)
